// src/hooks/useHydrateRotationFromUrl.ts
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { setRotationInRedux } from "../DesignTab/designSlice";

export const useHydrateRotationFromUrl = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const rotParam = searchParams.get("rot");
    if (rotParam == null) return;

    const parsed = Number(rotParam);
    if (!Number.isNaN(parsed)) {
      dispatch(setRotationInRedux(parsed));
    }
  }, [dispatch, searchParams]);
};
